function formatExpiryDate(timestamp: number) {
  // Timestamp is the actual expiration that is 24h later, to account for time zones etc.
  const date = new Date(timestamp - 24 * 60 * 60 * 1000);
  return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
}

export function SubscriptionExpirationDate(props: { timestamp: number }) {
  return <span>{formatExpiryDate(props.timestamp)}</span>;
}
